import { Alert, Stack, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RoutePending } from "../shared/components/RoutePending";

const repairSearchSchema = z.object({
  customer: z.string().uuid(),
  location: z.string().uuid(),
  documentType: z.string().uuid(),
});

// Legacy schema: accept ?tenant= param from printed QR codes.
const repairSearchLegacy = z.object({
  tenant: z.string().uuid().optional(),
  customer: z.string().uuid().optional(),
  location: z.string().uuid(),
  documentType: z.string().uuid(),
});

function RepairLinkError() {
  return (
    <Stack gap="md" maw={480} mx="auto" pt="xl" px="md">
      <Alert color="orange" radius="md">
        <Title order={3} size="h5" mb="xs">
          Invalid repair link
        </Title>
        <Text size="sm">
          This link appears to be incomplete or incorrect. Please scan the QR
          code again or contact hotel staff for a valid repair link.
        </Text>
      </Alert>
    </Stack>
  );
}

/**
 * @purpose Report a broken bike from the QR code, without an account, in under a minute
 * @primary Repair form
 * @persona staff-ikos
 */
export const Route = createFileRoute("/_public/repair")({
  validateSearch: (raw) => {
    const legacy = repairSearchLegacy.parse(raw);
    // Backward compat: ?tenant= from printed QR codes → ?customer=
    if (legacy.tenant && !legacy.customer) {
      return repairSearchSchema.parse({
        customer: legacy.tenant,
        location: legacy.location,
        documentType: legacy.documentType,
      });
    }
    return repairSearchSchema.parse(raw);
  },
  errorComponent: RepairLinkError,
  pendingComponent: RoutePending,
});
